"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}

export default function BlogPostLatestOptions({
    account,
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [title, setTitle] = React.useState(block?.options?.name);
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting title="General" noBorder>
                <div className="flex w-full flex-col gap-3">
                    <Input
                        label="Title"
                        id="title"
                        variant={"card"}
                        value={title}
                        onChange={(e) => {
                            setTitle(e.target.value);
                            blockUpdate({
                                ...block,
                                options: {
                                    ...block.options,
                                    name: e.target.value,
                                },
                            });
                        }}
                        onBlur={(e) => {
                            if (oldBlock?.options?.name !== e.target.value) {
                                setOldBlock({
                                    ...oldBlock,
                                    options: {
                                        ...oldBlock.options,
                                        name: e.target.value,
                                    },
                                });
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        name: e.target.value,
                                    },
                                });
                            }
                        }}
                    ></Input>
                    <div className="w-full space-y-1">
                        <div className="flex w-full items-center">
                            <Label variant={"toggle"} className="w-fit">
                                Amount of posts
                            </Label>
                            <Label
                                variant={"subtoggle"}
                                className="ml-auto w-fit"
                            >
                                {block.options.limit} Post
                                {block.options.limit > 1 ? "s" : ""}
                            </Label>
                        </div>
                        <Slider
                            max={5}
                            step={1}
                            min={1}
                            value={[block.options.limit || 1]}
                            onValueChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        limit: value,
                                    },
                                });
                            }}
                        />
                        <Label variant={"subtoggle"} className=" w-fit">
                            Showcase up to five of your latest blog posts
                        </Label>
                    </div>
                </div>
            </CardSetting>
        </div>
    );
}
